// src/components/BlogPostCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const BlogPostCard = ({ post }) => {
  const { title, publishedAt, slug } = post;
  const formattedDate = new Date(publishedAt).toLocaleDateString();

  return (
    <Link to={`/posts/${slug.current}`} style={{ textDecoration: 'none' }}>
      <div
        style={{
          border: '1px solid #ccc',
          padding: '1rem',
          borderRadius: '8px',
          marginBottom: '1rem',
          backgroundColor: '#fff',
          transition: 'box-shadow 0.2s ease-in-out',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)')}
        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = 'none')}
      >
        <h2 style={{ margin: '0 0 0.5rem 0', color: '#333' }}>{title}</h2>
        <p style={{ margin: 0, color: '#666' }}>{formattedDate}</p>
      </div>
    </Link>
  );
};

export default BlogPostCard;
